import { useQuery } from '@tanstack/react-query';
import { getBatteryData, getGeneratorData } from '../services/inputDataService';
import {
  assetTypeBattery,
  assetTypeGenerator,
  generatorTypeDiesel,
  generatorTypeGas,
} from '../Constants';

/**
 * The handeling of api data
 *
 * @param {string} type // The type of asset to be used
 * @return {Promise}
 */
export function useAssets(type) {
  return useQuery({
    refetchOnWindowFocus: false,
    queryKey: ['useAssets', type],
    queryFn: async () => {
      if (type === assetTypeGenerator) {
        return getGeneratorData().then(res => {
          // Sort generators into gas and diesel.
          const sortedGenerators = res.reduce(
            (acc, generator) => {
              if (generator.type === generatorTypeGas) {
                acc.gasGenerators.push(generator);
              } else if (generator.type === generatorTypeDiesel) {
                acc.dieselGenerators.push(generator);
              }
              return acc;
            },
            { gasGenerators: [], dieselGenerators: [] }
          );

          // Sort both arrays alphabetically by `name`
          sortedGenerators.gasGenerators.sort((a, b) => a.name.localeCompare(b.name));
          sortedGenerators.dieselGenerators.sort((a, b) => a.name.localeCompare(b.name));

          return sortedGenerators;
        });
      }
      if (type === assetTypeBattery) {
        return getBatteryData().then(res => {
          if (res.length > 0) {
            // Sort batteries alphabetically by `name`
            return res.sort((a, b) => a.name.localeCompare(b.name));
          }

          return res;
        });
      }
    },
  });
}
